/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, {
    useCallback, useEffect, useState, useContext, useRef
} from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';

// eslint-disable-next-line import/no-extraneous-dependencies
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useModal } from '@jutro/components';
import { QuestionSetComponent, platformMessages, FormModalPopover } from 'ml-components-platform-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLModifierComponent } from 'ml-components-common-react';
import { MLDriverVehicleUtil, MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLMultiLobsDataHolderService } from 'ml-services-common-react';
import { MLDisclosureUtil, MLHVQDefaultFieldsUtil } from 'ml-portals-util-js';
import {
    PriorInsuranceComponent,
    DriversListComponent,
    DriversTableActionComponent,
    VehiclesListComponent,
    AddExcludedDriverPopup,
    AddHouseholdMemberPopup,
    PriorMetSubmissionPopup,
    PriorMetSubmissionPopupMessages,
    PriorMetSubmissionPopupStyles
} from 'ml-capability-quoteandbind-common-react';
import metadata from './AdditionalInformation.metadata.json5';
import styles from './AdditionalInformation.module.scss'

import messages from './AdditionalInformation.messages';
import { UserService } from 'gw-capability-gateway';
import PATrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';
import { ScrollToError } from '@jutro/legacy/wizard-next';
import { useHistory } from "react-router-dom";

const PA_MODEL_PATH = 'lobData.personalAuto.coverables.value';
const PA_MODIFIER_PATH = 'lobData.personalAuto.modifiers_ML';
const PRIMARY_VEHICLE_REQ_STATE_PATH = 'baseData.isDriverPrimaryVehicleRequiredState_Ext.value';
const STATE_PATH = 'baseData.policyAddress.state.value.code';
const HALF_DRIVER = 50;
const accidentPreventionCode = ['PADriversRoleModiferPreventionCourse_ML', 'PADriverAccidentPrevention_ML'];
const residentStudentCode = 'PADriverResidentStudent_ML';
const WLBForSeniorsCode = 'PAWorkLossBenefitsForSeniors_Ext';
const multipolicyLobCodes = ['PAMultiplePolicyHomePolicyNumber_ML', 'PAMultiplePolicyRentersPolicyNumber_ML', 'PAMultiplePolicyCondoPolicyNumber_ML', 'PAMultiplePolicyMobilePolicyNumber_ML',
    'PAMultiplePolicyLandlordPolicyNumber_ML', 'PAMultiplePolicyLandlordCondoPolicyNumber_ML', 'PAMultiplePolicyBoatPolicyNumber_ML', 'PAMultiplePolicyUmbrellaPolicyNumber_ML', 'PAMulitplePolicyMotorCyclePolicyNumber_Ext', 'PAMulitplePolicyRecreationalVehPolicyNumber_Ext', 'PAMulitplePolicyOffRoadVehPolicyNumber_Ext'];

const PA_PREFILL_PATH = 'lobData.personalAuto.coverables.drivers[0].value.fromPrefill_ML';

const AdditionalInformation = (props) => {
    const modalApi = useModal();
    const {
        wizardData: submissionVM, updateWizardData, steps, goNext, jumpTo, currentStep, isSkipping
    } = props;

    const {
        onValidate, isComponentValid, registerComponentValidation
    } = useValidation('AdditionalInformationPage');

    const { nextStepVisited } = MLWizardNavUtil(props);

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const {
        getHouseholdDriverType,
        getExcludedDriverType,
        isVehicleEligibleForAccidentPrevention,
        getRatedDriversNonStudent,
        validateVehiclesHaveAssignmentsForEveryDriver,
        validateVehicleAssignmentPercentages,
        displayNonAPModifierLAMessage,
        isDriverHousehold
    } = MLDriverVehicleUtil();

    const {
        addErrorAlert,
        clearBlockAlerts
    } = MLNotificationBlockUtil();
    const isGPA = appConfig.portalCode === 'GPA';
    const isQB = appConfig.portalCode === "QB"
    const translator = useTranslator();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
    const DRIVERTYPE_TYPELIST = viewModelService.productMetadata.get('pc').types.getTypelist('DriverType_ML');
    const VEH_DRV_ERR = _.get(submissionVM, STATE_PATH) === 'LA' ? translator(messages.vehiclePercentageDriverError) : translator(messages.vehiclePrimaryDriverError);
    const TOTAL_PCT_ERROR = translator(messages.totalPercentageError);
    const ASSIGNMENT_REQ_ERR = translator(messages.assignmentRequiredError);
    const newPolicyReasonHelpTextMap = translator(messages.helptextMap);
    const newPolicyReasonHelpTextTitleMap = translator(messages.helptext);
    const redirectRef = useRef(false);
    const history = useHistory();

    const { refreshData } = useDataRefresh();

    const {
        HVQConsumerSteps
    } = appConfig;

    const isCompRaterDefaultsPage = new Set(HVQConsumerSteps).has(currentStep.mlStepName);
    const isHVQAdditionalInfoStep = currentStep.mlStepName === 'paHVQConsumerAddtlInfoToQuote';

    const isVehiclePrimaryDriverState = _.get(submissionVM, 'baseData.isVehiclePrimaryDriverState_Ext.value');
    const isVehiclePrimaryDriverPercentageState = _.get(submissionVM, 'baseData.isVehiclePrimaryDriverPercentageState_Ext.value');
    const vehicleDriversVM = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicleDrivers_Ext');
    const questionSets = submissionVM.lobData.personalAuto.questionSets_ML.value;
    const quoteID = submissionVM.quoteID.value;
    const paModifiers = _.get(submissionVM, PA_MODIFIER_PATH);
    const isPrimaryVehicleReqState = _.get(submissionVM, PRIMARY_VEHICLE_REQ_STATE_PATH);
    const state = _.get(submissionVM, STATE_PATH);
    const isExclusionAllowed = _.get(submissionVM, 'baseData.canExcludeDrivers_ML.value', true);

    const paModel = _.get(submissionVM, PA_MODEL_PATH);
    const { vehicles } = paModel;
    const [drivers, setDrivers] = useState(paModel.drivers);
    const ratedDrivers = drivers.filter((driver) => driver.type_ML === DRIVERTYPE_TYPELIST.getCode('rated').code);
    const [nonAccidentPreventionDisplayed, setNonAccidentPreventionDisplayed] = useState(false);
    const [priorInsuranceErrors, setPriorInsuranceErrors] = useState([]);
    const [vehicleDriverErrors, setVehicleDriverErrors] = useState([]);
    const [showErrors, setShowErrors] = useState(false);
    const [showPriorInsuranceErrors, setShowPriorInsuranceErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [excludedDrivers, setExcludedDrivers] = useState(drivers.filter((driver) => {
            return driver.type_ML === getExcludedDriverType();
        }));
    const [houseHoldDrivers, setHouseHoldDrivers] = useState(drivers.filter((driver) => {
            return isDriverHousehold(driver);
        }));

    if (paModifiers && paModifiers.lineModifiers.value) {
        paModifiers.lineModifiers.value.forEach(
            (mod) => {
                mod.savedFromPortal = true;
                mod.updated = true;
                mod.editMode_ML = true;

                if (multipolicyLobCodes.includes(mod.codeIdentifier_ML)) {
                    mod.isVisible_ML = false
                    mod.isInputValueRequired_ML = false
                    mod.editMode_ML = false
                    mod.savedFromPortal = false
                } else {
                    mod.isVisible_ML = true
                }
            }
        );
    }

    const [hasError, setHasError] = useState(false);

    const getVehicleEligbleAsPrimaryVehicles = useCallback(() => {
        return vehicles.filter((veh) => isVehicleEligibleForAccidentPrevention(veh))
    }, [isVehicleEligibleForAccidentPrevention, vehicles])


    const setVehicleAssignmentsToSingleDriver = useCallback((driver) => {
        const eligibleVehicles = getVehicleEligbleAsPrimaryVehicles()
        vehicleDriversVM.value = [];
        eligibleVehicles.forEach((veh) => {
            const vehicleDriver = viewModelService.create({}, 'pc', 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.VehicleDriverDTO');
            vehicleDriver.vehicleID.value = veh.fixedId;
            vehicleDriver.driverID.value = driver.fixedId;
            vehicleDriver.percentageDriven_Ext.value = 100;
            vehicleDriversVM.pushElement(vehicleDriver.value);
        });
    }, [getVehicleEligbleAsPrimaryVehicles, vehicleDriversVM, viewModelService]);


    useEffect(() => {
        if (!isSkipping) {
            if (isGPA) {
                UserService.getCurrentUser(authHeader).then((user) => {
                    PATrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Additional Information Page' });
                });
            } else {
                PATrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'Additional Information Page' }, true);
            }
        }
    }, [isSkipping]);

    useEffect(() => {
        submissionVM.value.cleanUpCompRaterMockPolicyNumbers();

        if (ratedDrivers.length === 1 && (isVehiclePrimaryDriverState || isVehiclePrimaryDriverPercentageState)) {
            setVehicleAssignmentsToSingleDriver(ratedDrivers[0]);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (appConfig.portalCode === 'QB' && (!isSkipping || (isSkipping && !skipOnResumeIf()))) {
            const multiPolicyPromise = LoadSaveService.assignPolicyNumbersToModifiers(submissionVM.value, authHeader);
            showProgressDialog(platformMessages.syncing, multiPolicyPromise, true);

            multiPolicyPromise.then((submissionData) => {
                _.set(paModifiers.lineModifiers, 'value', submissionData.lobData.personalAuto.modifiers_ML.lineModifiers);
                updateWizardData(submissionVM);
            })
        }
    }, []);

    useEffect(() => {
            clearBlockAlerts('priorInsuranceErrors');
            if (showPriorInsuranceErrors === true) {
                priorInsuranceErrors.forEach((error) => {
                    addErrorAlert(error, 'priorInsuranceErrors');
                    window.scrollTo(0, 0);
                });
            }
    }, [showPriorInsuranceErrors])

    const getPrimaryDriverList = useCallback((eligibleVehicles) => {
        const primaryDriverList = [];
        eligibleVehicles.forEach((el) => {
            const tmp = vehicleDriversVM.filter((vd) => vd.vehicleID && vd.vehicleID.value === el.fixedId);
            if (tmp !== undefined) {
                const r = Math.max(...tmp.map((ar) => ar.percentageDriven_Ext.value));
                primaryDriverList.push(tmp.find((t) => parseInt(t.percentageDriven_Ext.value, 10) === r).driverID.value);
            }
        });
        return primaryDriverList;
    }, [vehicleDriversVM]);

    const hasMissingRequiredDriverAssignment = useCallback(() => {
        let hasMissing = false;
        if (vehicleDriversVM.value.some((vd) => vd.driverID === null || vd.driverID === 0)) {
            addErrorAlert(ASSIGNMENT_REQ_ERR, 'assignmentRequiredError');
            hasMissing = true;
        } else {
            clearBlockAlerts('assignmentRequiredError')
        }
        return hasMissing;
    }, [ASSIGNMENT_REQ_ERR, addErrorAlert, clearBlockAlerts, vehicleDriversVM.value]);

    const primaryDriversError = useCallback(() => {
        let hasPrimaryDriversError = false;

        clearBlockAlerts('vehicleDriverError')

        if (hasMissingRequiredDriverAssignment()) {
            return true;
        }

        const eligibleVehicles = getVehicleEligbleAsPrimaryVehicles()
        const primaryDriverList = getPrimaryDriverList(eligibleVehicles);
        if (eligibleVehicles.length >= ratedDrivers.length) {
            const residentStudent = [];
            ratedDrivers.forEach((ratedDriver) => {
                ratedDriver.driverModifiers_ML.modifiers.forEach((modifier) => {
                    if (modifier.codeIdentifier_ML === residentStudentCode && modifier.chosenTermValue === 'true') {
                        residentStudent.push(ratedDriver);
                    }
                });
            });
            const resStudentArr = [];
            residentStudent.forEach((res) => {
                resStudentArr.push(res.fixedId);
            });
            vehicleDriversVM.value.forEach((res) => {
                if (res.percentageDriven_Ext === HALF_DRIVER) {
                    if (!hasPrimaryDriversError) {
                        addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                        hasPrimaryDriversError = true;
                    }
                }
            });

            ratedDrivers.forEach((el) => {
                if (!resStudentArr.includes(el.fixedId) && !primaryDriverList.includes(el.fixedId)) {
                    if (!hasPrimaryDriversError) {
                        addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                        hasPrimaryDriversError = true;
                    }
                }
            });
        } else {
            vehicleDriversVM.value.forEach((res) => {
                if (res.percentageDriven_Ext === HALF_DRIVER) {
                    if (!hasPrimaryDriversError) {
                        addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                        hasPrimaryDriversError = true;
                    }
                }
            });
            if (primaryDriverList.length !== new Set(primaryDriverList).size) {
                if (!hasPrimaryDriversError) {
                    addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                    hasPrimaryDriversError = true;
                }
            }
        }
        if (hasPrimaryDriversError) {
            window.scrollTo(0, 0);
        }

        return hasPrimaryDriversError;
    }, [VEH_DRV_ERR, addErrorAlert, clearBlockAlerts, getPrimaryDriverList, getVehicleEligbleAsPrimaryVehicles, hasMissingRequiredDriverAssignment, ratedDrivers, vehicleDriversVM.value]);

    const areVehiclePrimaryDriverAssignmentPercentagesInvalid = useCallback(() => {
        let areAssignmentsInvalid = false;
        const primaryDriverList = [];
        clearBlockAlerts('vehicleDriverError')
        clearBlockAlerts('assignmentRequiredError')
        clearBlockAlerts('totalPctError')

        vehicleDriversVM.value.forEach((vd) => {
            if (!vd.percentageDriven_Ext) {
                vd.percentageDriven_Ext = 0;
            }
        });

        const eligibleVehicles = getVehicleEligbleAsPrimaryVehicles();
        const ratedDriversNonStudent = getRatedDriversNonStudent(ratedDrivers);
        if (eligibleVehicles.length > 0) {
            if (!validateVehiclesHaveAssignmentsForEveryDriver(eligibleVehicles, ratedDrivers, vehicleDriversVM)) {
                addErrorAlert(ASSIGNMENT_REQ_ERR, 'assignmentRequiredError');
                areAssignmentsInvalid = true;
            }

            if (!validateVehicleAssignmentPercentages(eligibleVehicles, vehicleDriversVM)) {
                addErrorAlert(TOTAL_PCT_ERROR, 'totalPctError');
                areAssignmentsInvalid = true;
            }

            // capture primary drivers for all eligible vehicles
            let multiplePrimaryDrivers = false;
            eligibleVehicles.forEach((vehicle) => {
                const vehicleAssignments = vehicleDriversVM.value.filter((vd) => vd.vehicleID === vehicle.fixedId);
                if (vehicleAssignments.length > 0) {
                    const max = Number(Math.max(...vehicleAssignments.map((ar) => ar.percentageDriven_Ext)));
                    if (vehicleAssignments.filter((va) => va.percentageDriven_Ext === max).length > 1) {
                        multiplePrimaryDrivers = true;
                    }
                    primaryDriverList.push(vehicleAssignments.find((t) => parseInt(t.percentageDriven_Ext, 10) === max).driverID);
                }
            });

            if (multiplePrimaryDrivers) {
                addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                areAssignmentsInvalid = true;
            } else if (ratedDriversNonStudent.length >= eligibleVehicles.length) {
                // check that driver isn't primary on more than one vehicle
                if (primaryDriverList.length !== new Set(primaryDriverList).size) {
                    addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                    areAssignmentsInvalid = true;
                }
            } else {
                // check that each rated driver is primary on at least one vehicle
                ratedDriversNonStudent.forEach((driver) => {
                    if (!primaryDriverList.includes(driver.fixedId)) {
                        addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                        areAssignmentsInvalid = true;
                    }
                });
            }
        } else if (vehicleDriversVM.length > 0) {
            vehicleDriversVM.value = [];
        }
        return areAssignmentsInvalid;
    }, [ASSIGNMENT_REQ_ERR, TOTAL_PCT_ERROR, VEH_DRV_ERR, addErrorAlert, clearBlockAlerts, getRatedDriversNonStudent, getVehicleEligbleAsPrimaryVehicles, ratedDrivers, validateVehicleAssignmentPercentages, validateVehiclesHaveAssignmentsForEveryDriver, vehicleDriversVM]);

    const addressVM = _.get(submissionVM, 'baseData.policyAddress');
    const shouldShowVehicleListSection = useCallback(() => {
        let primaryDriverRequired = false;
        if ((isVehiclePrimaryDriverState || isVehiclePrimaryDriverPercentageState)
            && drivers.length > 1) {
            drivers.forEach((driver) => {
                _.get(driver, 'driverModifiers_ML.modifiers', []).forEach((modifier) => {
                    if (accidentPreventionCode.indexOf(modifier.codeIdentifier_ML) > -1) {
                        if (modifier.chosenTermValue === 'true') primaryDriverRequired = true;
                    }
                });
            });
        }
        if (paModifiers && paModifiers.lineModifiers.value) {
            paModifiers.lineModifiers.value.forEach((modifier) => {
                if (WLBForSeniorsCode.indexOf(modifier.codeIdentifier_ML) > -1) {
                    if ((modifier.chosenTermValue === 'true') && (addressVM.state.value && addressVM.state.value.code === 'MN')) primaryDriverRequired = true;
                }
            }
            );
        }
        return primaryDriverRequired;
    }, [drivers, isVehiclePrimaryDriverPercentageState, isVehiclePrimaryDriverState]);


    const onUpdateErrors = useCallback((val) => {
        setPriorInsuranceErrors(val);
    }, []);

    const onUpdateDrivers = useCallback((val) => {
        setDrivers(val);
    }, []);

    const validateVehicleDrivers = useCallback(() => {
        if (shouldShowVehicleListSection()) {
            if (isVehiclePrimaryDriverState) {
                return !primaryDriversError();
            }

            if (isVehiclePrimaryDriverPercentageState) {
                return !areVehiclePrimaryDriverAssignmentPercentagesInvalid();
            }
        }
        return true;
    }, [shouldShowVehicleListSection, isVehiclePrimaryDriverState, isVehiclePrimaryDriverPercentageState, primaryDriversError, areVehiclePrimaryDriverAssignmentPercentagesInvalid]);


    const questionSetsAspects = submissionVM.lobData.personalAuto.questionSets_ML.aspects;
    const validateQuestionSets = useCallback(() => {
        if (!_.isEmpty(questionSetsAspects) && (!questionSetsAspects.valid
            || !questionSetsAspects.subtreeValid)) {
            return false;
        }
        return true;
    }, [questionSetsAspects]);

    const performPageValidation = useCallback(() => {
        return validateQuestionSets() && submissionVM.aspects.valid && submissionVM.aspects.subtreeValid && !hasError;
    }, [hasError, submissionVM.aspects.subtreeValid, submissionVM.aspects.valid, validateQuestionSets]);

    useEffect(() => {
        registerComponentValidation(performPageValidation);
    }, [performPageValidation, registerComponentValidation]);

    const syncQuestionSets = useCallback((aQuestionSetAnswersValue, focusTarget) => {
        if (questionSets) {
            const syncPromise = LoadSaveService.syncQuestionSetML(quoteID, [aQuestionSetAnswersValue]);
            showProgressDialog(platformMessages.syncingQuestions, syncPromise, true);
            syncPromise.then((updatedQuestions) => {
                const newVm = viewModelService.clone(submissionVM);
                const transformedQuestions = {};
                updatedQuestions.forEach((q) => { transformedQuestions[q.code] = q; });
                _.set(newVm, 'lobData.personalAuto.questionSets_ML.preQualification.value', transformedQuestions.PAPersonalAutoPreQual);
                _.set(newVm, 'lobData.personalAuto.questionSets_ML.priorInsurance.value', transformedQuestions.PAPriorInsurance_ML);
                _.set(newVm, 'lobData.personalAuto.questionSets_ML.houseAdditionalInformation.value', transformedQuestions.PAHouseAdditionalInformation_ML);
                updateWizardData(newVm);

               if (focusTarget && typeof focusTarget.focus === "function") {
                    focusTarget.focus();
                }
            });
        }
    }, [questionSets, LoadSaveService, quoteID, showProgressDialog, viewModelService, submissionVM, updateWizardData]);

    const clearErrorMessages = useCallback(() => {
        drivers.forEach((driver) => {
            if (driver.error) {
                // eslint-disable-next-line no-useless-return
                return;
            }
        });
        setHasError(false);
    }, [drivers]);

    const addErrorMessage = useCallback(() => {
        addErrorAlert(messages.driverError, 'driverError');
    }, [addErrorAlert]);

    const validateNonRatedDrivers = useCallback(() => {
        const driversVM = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.children', []);
        setHasError(driversVM.some((driverVM) => {
            return !driverVM.aspects.valid || !driverVM.aspects.subtreeValid;
        }));
        if (hasError) {
            addErrorMessage();
        }
    }, [addErrorMessage, hasError, submissionVM]);

    const checkOwnsResidenceModifier = (mod, copiedView) => {
        if (mod.patternCode.value === 'z70hmvhmucbde2eo899j9kmgjdb') {
            if (mod.chosenTermValue.value) {
                if (!copiedView.lobData.personalAuto.modifiers_ML.yearsAtCurrentResidence) {
                    copiedView.lobData.personalAuto.modifiers_ML.yearsAtCurrentResidence = 0;
                }
            }
        }
    };

    const syncModifiers = (submissionData, mlModifier) => {
        submissionData.forEach((mod) => {
            const oldMod = mlModifier.value.find((value) => {
                return value.patternCode === mod.patternCode;
            });
            _.set(mod, 'chosenTermValue', oldMod ? oldMod.chosenTermValue : false);
            _.set(mod, 'savedFromPortal', true);
            _.set(mod, 'editMode_ML', true);

            if (!multipolicyLobCodes.includes(mod.codeIdentifier_ML)) {
                _.set(mod, 'savedFromPortal', true);
                _.set(mod, 'editMode_ML', true);
            }
        });
        _.set(mlModifier, 'value', submissionData);
    };

    const syncModifierDependentQuestions = (submissionData, mlModifier) => {
        if (mlModifier.yearsAtCurrentResidence) {
            mlModifier.yearsAtCurrentResidence.value = submissionData.yearsAtCurrentResidence;
        }
    };

    const updateModifier = async (mod) => {
        _.set(mod, 'updated.value', true);
        const validMods = [];
        const copiedModel = viewModelService.clone(submissionVM);

        for (let i = 0; i < paModifiers.lineModifiers.length; i += 1) {
            const modifier = paModifiers.lineModifiers.children[i];
            checkOwnsResidenceModifier(modifier, copiedModel);
            if (modifier.aspects.subtreeValid) {
                validMods.push(modifier.value);
            }
        }

        _.set(copiedModel, 'lobData.personalAuto.modifiers_ML.lineModifiers', validMods);

        showProgressDialog(platformMessages.syncing);
        try {
            const submissionData = await LoadSaveService.updateModifiers(copiedModel.value)
            syncModifiers(submissionData.lobData.personalAuto.modifiers_ML.lineModifiers, paModifiers.lineModifiers);
            syncModifierDependentQuestions(submissionData.lobData.personalAuto.modifiers_ML, paModifiers);
            updateWizardData(submissionVM);
        } catch (e) {
            console.error(e);
        } finally {
            hideProgressDialog(true);
        }
    };

    const isAccidentPreventionCourse = useCallback(() => {
        let nonAcciPrevModifier = false;
        if (state === 'LA') {
            drivers.forEach((driver) => {
                if (driver.driverModifiers_ML.modifiers) {
                    driver.driverModifiers_ML.modifiers.forEach((modifier) => {
                        if (accidentPreventionCode.indexOf(modifier.codeIdentifier_ML) > -1) {
                            if (modifier.chosenTermValue === 'false') nonAcciPrevModifier = true;
                        }
                    });
                }
            });
        }
        return nonAcciPrevModifier;
    }, [drivers, state]);

    const isFieldDefaultedByHVQ = (inputID) => {
        return submissionVM.value.isConsumerCompRater()
            && MLHVQDefaultFieldsUtil.isFieldDefaultedByHVQ(submissionVM.value.compRaterVendorName_ML, inputID, currentStep.mlStepName);
    };

    const showPriorInsuranceMetOrFarmers = useCallback(() => {
        const answers = _.get(questionSets, "priorInsurance.answers.CurrentInsuranceProvider_ML")
        return (answers === 'CurrentInsuranceProviderFarmers_ML' || answers === 'CurrentInsuranceProviderMetLifePropertyCasualty_ML')
    }, [questionSets])

    const showPriorMetSubmissionModal = useCallback(() => {
        const disableButton = () => {
            return _.isUndefined(_.get(submissionVM, 'baseData.newPolicyReason_Ext.value', undefined));
        };

        const mapAvailableValues = (values) => {
            if (submissionVM.isSubmitAgent.value === true) {
                values = values.filter((reason) => reason.code !== 'purchase_direct');
            }

            return values.map((type) => {
                return {
                    code: type.code,
                    name: translator({
                        id: type.name,
                        defaultMessage: type.name
                    })
                };
            });
        };

        const overrides = {
            newPolicyReasonRadioButtons: {
                helpTextTitleMap: newPolicyReasonHelpTextTitleMap,
                helpTextMap: newPolicyReasonHelpTextMap,
                availableValues: mapAvailableValues(_.get(submissionVM, 'baseData.newPolicyReason_Ext.aspects.availableValues', [])),
                value: _.get(submissionVM, 'baseData.newPolicyReason_Ext.value')
            },

            tooltipContainerQb: {
                visible: appConfig.portalCode === 'QB'
            }
        };

        const componentProps = {
            title: translator(PriorMetSubmissionPopupMessages.priorMetPopupHeader),
            uiProps: PriorMetSubmissionPopup.pageContent,
            actionBtnLabel: platformMessages.mlContinue,
            viewModel: submissionVM.baseData,
            disableButton: disableButton,
            modalBodyStyles: PriorMetSubmissionPopupStyles,
            overrideProps: overrides,
            onSaveAction: (() => {
                goNext();
                return true;
            }),
            showXCloseButton: false
        }

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, [goNext, newPolicyReasonHelpTextMap, newPolicyReasonHelpTextTitleMap, submissionVM, translator])

    const onNext = useCallback(async () => {
        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PATrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Additional Information Page', action: 'Additional Information Submitted' });
            });
        } else {
            PATrackEvent('Quote Step Submitted', false, submissionVM, null, { step: 'Additional Information Page', action: 'Additional Information Submitted' }, true);
        }
        if (!((isComponentValid || isQB) && submissionVM.aspects.valid && submissionVM.aspects.subtreeValid)) {
            setShowErrors(true);
            setErrorTimestamp(errorTimestamp + 1);
            return false;
        }
        if (isQB) {
            const maxNumberOfSpouseAllowed = _.get(submissionVM, 'maxNumberOfSpouse.value', 1);
            const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value', []);

            const spouseDrivers = drivers.filter(
                (driver) => driver?.relationshipToInsured_ML === 'spouse'
            );

            if (spouseDrivers.length > maxNumberOfSpouseAllowed) {
                clearBlockAlerts('maxNumberOfSpouseAllowed_ML');
                addErrorAlert(translator(messages.maxNumberOfSpouseAllowed_ML), 'maxNumberOfSpouseAllowed_ML');
                return false;
            }

            clearBlockAlerts('maxNumberOfSpouseAllowed_ML');
        }

        const highestLevelOfEducation = submissionVM.lobData.personalAuto.questionSets_ML.houseAdditionalInformation;
            
        if (highestLevelOfEducation.answers.value.PAHighestLevelOfEducation_ML === null){
            clearBlockAlerts('highestLevelOfEducation_ML')
            addErrorAlert(messages.highestLevelOfEducation_ML, 'highestLevelOfEducation_ML');
            return false;
        } else {
            clearBlockAlerts('highestLevelOfEducation_ML')
        }

        if (priorInsuranceErrors.length !== 0) {
            setTimeout(() => {
                window.scrollTo(0, 0);
                setShowPriorInsuranceErrors(true);
            }, 500);
            return false;
        }

        if (!nonAccidentPreventionDisplayed && shouldShowVehicleListSection() && isAccidentPreventionCourse()) {
            displayNonAPModifierLAMessage();
            setNonAccidentPreventionDisplayed(true);
            return false;
        }

        if (!validateVehicleDrivers()) {
            return false;
        }

        _.set(submissionVM, 'portalCurrentStep_ML.value', 'paAddtlInfoToQuote');
        if (submissionVM.value.isConsumerCompRater()) {
            showProgressDialog(platformMessages.saveSubmission);
            MLDisclosureUtil.setRequoteAfterMvr(submissionVM.quoteID.value, false);
            try {
                const submissionData = await LoadSaveService.assignPolicyNumbersToModifiers(submissionVM.value, authHeader);
                _.set(paModifiers.lineModifiers, 'value', submissionData.lobData.personalAuto.modifiers_ML.lineModifiers);
                updateWizardData(submissionVM);
                const res = await LoadSaveService.updateQuotedSubmission(submissionVM.value, authHeader);
                submissionVM.value = res;
                MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'paAddtlInfoToBuy');
                if (showPriorInsuranceMetOrFarmers()) {
                    showPriorMetSubmissionModal();
                } else {
                    if (!nextStepVisited()) {
                        return submissionVM;
                    }
                    goNext();
                }
            } finally {
                hideProgressDialog();
            }
        } else {
            try {
                showProgressDialog(platformMessages.saveAndQuoteSubmission);
                const submissionData = await LoadSaveService.assignPolicyNumbersToModifiers(submissionVM.value, authHeader);
                 _.set(paModifiers.lineModifiers, 'value', submissionData.lobData.personalAuto.modifiers_ML.lineModifiers);
                updateWizardData(submissionVM);
                const res = await LoadSaveService.saveAndQuoteSubmission(submissionVM.value, authHeader);
                submissionVM.value = res;
                MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails');
                if (showPriorInsuranceMetOrFarmers()) {
                    showPriorMetSubmissionModal();
                } else {
                    if (!nextStepVisited()) {
                        return submissionVM;
                    }
                    goNext();
                }
            }
            finally {
                    hideProgressDialog();
            }
        }
        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [LoadSaveService, authHeader, currentStep, displayNonAPModifierLAMessage, goNext, hideProgressDialog, isAccidentPreventionCourse, isComponentValid, nonAccidentPreventionDisplayed, priorInsuranceErrors, shouldShowVehicleListSection, showPriorInsuranceMetOrFarmers, showPriorMetSubmissionModal, showProgressDialog, submissionVM, validateVehicleDrivers]);

    const showPriorCarrierMessage = () => {
        return !_.isEmpty(submissionVM.lobData.personalAuto.questionSets_ML.priorInsurance.readOnlyAnswers_Ext.value);
    };

    const nextStepText_Ext = () => {
        return isCompRaterDefaultsPage ? (
            <FormattedMessage
                {...messages.hvqNextDesc}
                values={{
                    finalVehicleAndDriverDetails: (
                        <strong>{translator(messages.hvqFinalVehAndDriverDetails)}</strong>
                    )
                }}
            />
        ) : (
            <FormattedMessage
                {...messages.weWillReviewYourQuoteNext}
                values={{
                    reviewYourQuote: (
                        <strong>{translator(messages.reviewYourQuote)}</strong>
                    )
                }}
            />
        );
    };

    const overrides = {
        priorInsuranceComponent: {
            submissionVM: submissionVM,
            updateWizardData: updateWizardData,
            onValidate: onValidate,
            onUpdateErrors: onUpdateErrors,
            syncQuestionSets: syncQuestionSets,
            showPriorInsuranceErrors,
            updateShowPriorInsuranceErrors: setShowPriorInsuranceErrors,
            showErrors,
            isFieldDefaultedByHVQ
        },
        paAdditionalInformationContainer: {
             className: isQB ? 'qbPadding' : ''
        },
        priorInsuranceAlert: {
            visible: showPriorCarrierMessage() && !isQB
        },
        houseadditionalquestionset: {
            labelPosition: 'top',
            model: submissionVM,
            onValidate: onValidate,
            onValueChange: syncQuestionSets,
            isFieldDefaultedByHVQ
        },
        modifierComponent: {
            modifier: paModifiers.lineModifiers,
            updateModifier: updateModifier,
            isFieldDefaultedByHVQ: isFieldDefaultedByHVQ,
            onValidate: onValidate,
            showValidationErrors: showErrors,
            visible: !_.isUndefined(paModifiers),
            showPopover: false
        },
        driversListComponent: {
            paModel: paModel,
            refreshData,
            isPrimaryVehicleReqState: isPrimaryVehicleReqState,
            state: state,
            isFieldDefaultedByHVQ,
            showErrors
        },
        tooltipContainerQb: {
            visible: isExclusionAllowed && isQB
        },
        excludedDriversSection: {
            visible: isExclusionAllowed
        },
        excludedDriversComponent: {
            submissionVM: submissionVM,
            updateWizardData: updateWizardData,
            validateNonRatedDrivers: validateNonRatedDrivers,
            clearErrors: clearErrorMessages,
            steps: steps,
            jumpTo: jumpTo,
            hideAdd: false,
            hideEdit: false,
            hideRemove: false,
            hideInsure: false,
            hideMaritalStatus: false,
            driverType: getExcludedDriverType(),
            messages: AddExcludedDriverPopup.excludedDriversMessages,
            addDriverPopupMetadata: AddExcludedDriverPopup.metadata,
            addDriverPopupModalBodyStyles: AddExcludedDriverPopup.styles,
            setTypedDrivers: setExcludedDrivers,
            typedDrivers: excludedDrivers,
        },
        householdMembersComponent: {
            submissionVM: submissionVM,
            updateWizardData: updateWizardData,
            validateNonRatedDrivers: validateNonRatedDrivers,
            clearErrors: clearErrorMessages,
            steps: steps,
            jumpTo: jumpTo,
            hideAdd: false,
            hideEdit: false,
            hideRemove: false,
            hideInsure: false,
            hideMaritalStatus: true,
            driverType: getHouseholdDriverType(),
            messages: AddHouseholdMemberPopup.householdMessages,
            addDriverPopupMetadata: AddHouseholdMemberPopup.metadata,
            addDriverPopupModalBodyStyles: AddHouseholdMemberPopup.styles,
            setTypedDrivers: setHouseHoldDrivers,
            typedDrivers: houseHoldDrivers
        },
        vehiclesListComponent: {
            visible: shouldShowVehicleListSection(),
            isVehiclePrimaryDriverState,
            isVehiclePrimaryDriverPercentageState,
            drivers: ratedDrivers,
            vehicles,
            vehicleDrivers: vehicleDriversVM,
            vehicleDriverErrors,
            setVehicleDriverErrors
        },
        nextDescription: {
            content: nextStepText_Ext(),
        },
        hvqPageTitle: {
            visible: isHVQAdditionalInfoStep
        },
        hvqPageSubTitle: {
            visible: isHVQAdditionalInfoStep
        }
    };

    const resolvers = {
        resolveComponentMap: {
            priorinsurancecomponent: PriorInsuranceComponent,
            driverslistcomponent: DriversListComponent,
            questionset: QuestionSetComponent,
            excludeddriverscomponent: DriversTableActionComponent,
            householdmemberscomponent: DriversTableActionComponent,
            modifiercomponent: MLModifierComponent,
            vehicleslistcomponent: VehiclesListComponent
        },
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onValidate: onValidate,
            onUpdateErrors: onUpdateErrors,
            onUpdateDrivers: onUpdateDrivers,
            validateNonRatedDrivers: validateNonRatedDrivers,
            onNext: onNext
        }
    };

    const skipOnResumeIf = () => {
        // Temporary - only allow skipping for bound policies
        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        if (submissionVM.value.isConsumerCompRater()) {
            return MLMultiLobsDataHolderService.hasCompletedStep(currentStep.mlStepName);
        }

        if (currentStep.mlStepName === 'paHVQConsumerAddtlInfoToQuote' && !(submissionVM.hvqQuoteID_ML && submissionVM.hvqQuoteID_ML.value)) {
            return true;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'paAddtlInfoToQuote') {
            return false;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
            submissionVM.hvqQuoteID_ML.value &&
            submissionVM.isBundle_ML.value) {
            return true;
        }

        if (submissionVM.isBundle_ML.value
            && submissionVM.baseData.status_ML !== 'Draft') {
            return true;
        }

        if (submissionVM.lobData.personalAuto.questionSets_ML.value) {
            const highestLevelOfEducation = submissionVM.lobData.personalAuto.questionSets_ML.houseAdditionalInformation;
            return highestLevelOfEducation.answers.value.PAHighestLevelOfEducation_ML !== null;
        }
        return false;
    };

    return (
        <WizardPage
            showPrevious={false}
            showCancel={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited()}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={nextStepText_Ext()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                model={submissionVM}
                showErrors={showErrors}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                onValidationChange={onValidate}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
};

AdditionalInformation.propTypes = wizardProps;
export default AdditionalInformation;
